let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("asvK9"), load("barSq"), load("aBa7j"), load("gctEz"), load("hPZE5"), load("QTjdE")]).then(() => parcelRequire('cQCfJ'));